import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const itemOtherPayloadSchema = z
    .object({
        raw: z.record(z.string(), z.json()),
    })
    .strip();

export const itemOtherDefinitions = {
    item_other: defineInvisible('item_other', {
        disposition: 'invisible',
        schema: itemOtherPayloadSchema,
        malformed: { kind: 'skip' },
        evidence: null,
    }),
} as const;

export const itemOtherContractFixtures = {
    valid: {
        raw: {
            type: 'future_item',
            detail: 'Internal item detail',
        },
    },
    malformed: {
        raw: ['not', 'an', 'object'],
    },
} as const;
